<template>
  <div class="grid gap-2">
    <div class="grid gap-6" v-auto-animate>
      <FatFiltersTags :groupId="regionsId" :heading="$t('fat.filters.regions.heading')" v-if="regionsId" />
      <FatFiltersTags :groupId="2" :heading="$t('fat.filters.cuisines.heading')" />
      <FatFiltersTags :groupId="7" :heading="$t('fat.filters.amenities.heading')" />
      <FatFiltersTags :groupId="1" :heading="$t('fat.filters.dishes.heading')" />
    </div>
    <!-- <div v-if="fat.tagIds?.length" class="my-2">
      <button class="button-sand-outline w-full" @click="fat.resetTags">
        <div class="flex items-center gap-2 justify-center">
          <AtomIcon name="circle-xmark" class="text-sm" />
          <span class="text-xs" v-html="$t('fat.filters.clear', { count: fat.tagIds?.length })" />
        </div>
      </button>
    </div> -->
  </div>
</template>

<script setup>
const fat = useFatStore()

// Find regions ID based on city ID and user location 
const regionsId = computed(() => {
  if (fat.hasLocation || fat.hasUserLocation) return null
  if (fat.cityId === 86915) return 8
  if (fat.cityId === 86855) return 9
  if (fat.cityId === 86887) return 10
  return null
})
</script>